import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type { AccessibleCashRegistersResponseData } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const CASH_REGISTERS_LIST_QUERY_KEY = 'cash_registers_list';

// The pickers list every register the user may touch — override the RTable default (10 rows).
const CASH_REGISTER_OPTIONS_PAGE_SIZE = 1000;

type AccessibleOptionsParams = {
  url: string;
  isEnabled: boolean;
  filters?: Record<string, unknown>;
};

export const cashRegisterKeys = {
  all: () => ['cashRegisters'] as const,
  accessibleOptions: (props: AccessibleOptionsParams) =>
    [
      ...cashRegisterKeys.all(),
      'accessibleOptions',
      props.url,
      props.filters,
    ] as const,
};

export const cashRegisterQueries = {
  accessibleOptions: (props: AccessibleOptionsParams) =>
    queryOptions({
      queryKey: cashRegisterKeys.accessibleOptions(props),
      queryFn:
        props.isEnabled && props.url
          ? () =>
              HttpClient.request<AccessibleCashRegistersResponseData>({
                method: 'GET',
                url: props.url,
                params: {
                  size_per_page: CASH_REGISTER_OPTIONS_PAGE_SIZE,
                  ...(props.filters ? { filters: props.filters } : {}),
                },
              })
          : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),
};
